import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import GetInTouch from "./sections/GetInTouch";
import OurLocation from "./sections/OurLocation";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <GetInTouch />
      <OurLocation />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}